import { FunctionComponent, useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import { NO_AREA_PLACEHOLDER } from '../features/propertyAssociation/propertyAssociationEnums';
import { usePropertyAssociationConfig } from '../features/propertyAssociation/propertyAssociationService';
import SelectPropertyAssociationArea from '../features/propertyAssociation/SelectPropertyAssociationArea';
import { useLastAreaId } from '../features/propertyAssociation/useLastAreaId';

const PropertyAssociation: FunctionComponent = () => {
    const { propertyAssociationId } = useParams<{ propertyAssociationId: string }>();
    const { propertyAssociationConfig } = usePropertyAssociationConfig(propertyAssociationId!);
    const location = useLocation();
    const { areas } = propertyAssociationConfig!;

    // Get returnPath from navigation state (to return to the same page after area selection)
    const returnPath = (location.state as { returnPath?: string } | null)?.returnPath;

    // Clear lastAreaId for this property association when navigating to area selection
    const { clearLastAreaId } = useLastAreaId(propertyAssociationId);
    useEffect(() => {
        clearLastAreaId();
    }, [clearLastAreaId]);

    // Auto-navigate if no areas (PA acts as area)
    if (!areas || areas.length === 0) {
        return <Navigate to={`${NO_AREA_PLACEHOLDER}${returnPath ?? '/'}`} replace state={location.state} />;
    }

    // Auto-navigate if only one area
    if (areas.length === 1) {
        return <Navigate to={`${areas[0].propertyAssociationAreaId}${returnPath ?? '/'}`} replace state={location.state} />;
    }

    return <SelectPropertyAssociationArea propertyAssociation={propertyAssociationConfig!} />;
};

export default PropertyAssociation;
